export default {
    id: -1,
    name: 'aktuellesNote',
    value: "Ältere Informationen können beim Sekretär der Kantonalkirche angefragt werden.",
    target: "/",
    Post: false,
    date: 20200111,
}